// Las dos ruletas de "Fichaje o No Fichaje".

/**
 * Ruleta inicial: un beneficio para toda la partida. Los tres revelan algo de CADA maletín antes
 * de abrirlo, así que la elección a ciegas deja de ser puro azar y pasa a ser una lectura.
 */
export const BENEFICIOS = [
    { id: 'pais',       icono: 'globo',  titulo: 'Nacionalidad',  detalle: 'Cada maletín muestra de qué país es el jugador.' },
    { id: 'posiciones', icono: 'pin',    titulo: 'Posiciones',    detalle: 'Cada maletín muestra en qué puestos puede jugar.' },
    { id: 'club',       icono: 'escudo', titulo: 'Un club',       detalle: 'Cada maletín muestra uno de los clubes donde jugó, al azar.' },
];

/**
 * Ruleta de después de rechazar un trato. Es opcional: el jugador decide si gira.
 * `bueno` pinta el gajo de verde o rojo. `color` lo pisa cuando el premio no es ni una cosa ni
 * la otra: la apuesta va en amarillo porque podés salir ganando o perdiendo segun como la juegues.
 */
export const PREMIOS = [
    { id: 'sobre',      bueno: true,  icono: 'sobre', titulo: 'Sobre dorado',
      detalle: 'Te llevás uno de los 3 mejores jugadores para un puesto que tengas libre.' },
    { id: 'calavera',   bueno: false, icono: 'calavera', titulo: 'Calavera',
      detalle: 'El mejor jugador de tu plantel desaparece.' },
    { id: 'switch_bueno', bueno: true, icono: 'subeJugador', titulo: 'Cambio a favor',
      detalle: 'Un jugador tuyo al azar se convierte en uno de más valor.' },
    { id: 'switch_malo', bueno: false, icono: 'bajaJugador', titulo: 'Cambio en contra',
      detalle: 'Un jugador tuyo al azar se convierte en uno de menos valor.' },
    { id: 'autoabrir',  bueno: true, icono: 'apurado', titulo: 'Manos apuradas',
      detalle: 'En la próxima ronda se abren solos los maletines más baratos: te sacan de encima los cascotes.' },
    { id: 'apuesta',    bueno: true,  color: 'amarillo', icono: 'apuesta', titulo: 'La apuesta',
      detalle: 'Cinco cartas dadas vuelta. Das vuelta una y decidís: ¿seguís o frenás?' },
    { id: 'suben',      bueno: true,  icono: 'mercadoCaro', titulo: 'Mercado caro',
      detalle: 'En la próxima ronda todos los maletines valen más de 30M.' },
    { id: 'bajan',      bueno: false, icono: 'mercadoBarato', titulo: 'Mercado barato',
      detalle: 'En la próxima ronda ningún maletín pasa los 40M.' },
];

export const premioAlAzar = () => PREMIOS[Math.floor(Math.random() * PREMIOS.length)];

/**
 * Aperturas de una ronda según la configuración.
 *
 * Siempre queda UN maletín rival sin abrir: si se abren todos, la última oferta se calcula contra
 * tu propio maletín y el Banquero te canta lo que tenés adentro.
 *
 * Con 8 maletines solo hay 7 rivales, y repartir 6 aperturas en 3 tandas deja tandas de 2, 2 y 2
 * con muy poco que abrir entre oferta y oferta — por eso con 8 el juego fuerza 2 ofertas.
 */
export function aperturasPara(maletines, ofertas) {
    if (maletines === 8) return [4, 2];                     // 6 de 7 rivales
    return ofertas === 3 ? [4, 2, 2] : [5, 3];              // 8 de 9 rivales
}

/** Cuántos maletines se abren solos con "Manos apuradas". */
export const autoAperturas = (maletines) => (maletines === 8 ? 2 : 3);

/**
 * Cuántos maletines se pueden abrir realmente en una tanda.
 *
 * Siempre tiene que sobrevivir un rival cerrado, si no la última oferta se calcula contra tu
 * propio maletín. Y la tanda no puede pedir más de lo que queda: "Manos apuradas" abre 2 o 3 de
 * entrada, y sin acotar, el juego terminaba pidiendo abrir maletines que ya no existían y se
 * trababa sin ninguna opción posible.
 */
export function aperturasDisponibles(pedidas, rivalesCerrados) {
    return Math.max(0, Math.min(pedidas, rivalesCerrados - 1));
}
